import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { staggerContainer, staggerItem } from "@/lib/motion"
import { Button } from "@/components/ui/button"

interface SectionHeaderProps {
  eyebrow?: string
  headline: string
  subheadline?: string
  ctaText?: string
  ctaHref?: string
  align?: "center" | "left"
  className?: string
}

export default function SectionHeader({
  eyebrow,
  headline,
  subheadline,
  ctaText,
  ctaHref,
  align = "center",
  className = "",
}: SectionHeaderProps) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left"
  const maxWidthClass = align === "center" ? "max-w-3xl" : "max-w-4xl"

  return (
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      className={`${alignClass} ${maxWidthClass} ${className}`}
    >
      {eyebrow && (
        <motion.p
          variants={staggerItem}
          className="text-sm font-semibold uppercase tracking-wider text-accent mb-4"
        >
          {eyebrow}
        </motion.p>
      )}

      <motion.h2
        variants={staggerItem}
        className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6"
      >
        {headline}
      </motion.h2>

      {subheadline && (
        <motion.p
          variants={staggerItem}
          className="text-lg md:text-xl text-muted-foreground mb-8 leading-relaxed"
        >
          {subheadline}
        </motion.p>
      )}

      {ctaText && ctaHref && (
        <motion.div variants={staggerItem}>
          <Button
            asChild
            size="lg"
            className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-8 py-6 text-base rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200"
          >
            <Link to={ctaHref}>{ctaText}</Link>
          </Button>
        </motion.div>
      )}
    </motion.div>
  )
}
